module.exports = __webpack_public_path__ + "img/SWP_Shield_06 (2).f51d6592.png";